type ChatWidgetProps = {
  workspaceId: number;
};

function ChatWidget({ workspaceId: _workspaceId }: ChatWidgetProps) {
  return null;
}

export default ChatWidget;
